import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ProductEndpoints {
  constructor(private http: HttpClient) {}
}
